import { render, staticRenderFns } from "./OutsourceList.vue?vue&type=template&id=54130b8a&scoped=true&"
import script from "./OutsourceList.vue?vue&type=script&lang=ts&"
export * from "./OutsourceList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54130b8a",
  null
  
)

export default component.exports